export enum PartnerType {
    Acceptance = 1,
    Delivery = 2,
    Transhipment = 3
}